import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-inventory-parent',
    templateUrl: './inventory-parent.component.html',
    styleUrls: ['./inventory-parent.component.scss'],
    standalone: false
})
export class InventoryParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
